
import { Component, Prop, Vue } from 'nuxt-property-decorator'

const HowItWorksCards = () => ({
  component: import(
    /* webpackChunkName: "sections" */ '~/components/sections/how-it-works/Cards.vue'
  ),
  delay: 200,
  timeout: 3000,
})

const HowItWorksCardsItem = () => ({
  component: import(
    /* webpackChunkName: "sections" */ '~/components/sections/how-it-works/CardsItem.vue'
  ),
  delay: 200,
  timeout: 3000,
})

@Component({
  components: {
    HowItWorksCards,
    HowItWorksCardsItem,
  },
})
export default class BlackFridayHiw extends Vue {
  @Prop({ type: String, default: 'mobile' })
  planType!: string

  @Prop({ type: String, default: '' })
  providerName!: string

  get items () {
    const basePath = this.planType === 'internet' ? 'howItWorks.internetPlans' : 'howItWorks.cards'
    const providerSpecificPath = 'howItWorks.providerSpecific'
    const path = this.providerName ? providerSpecificPath : basePath

    return [
      {
        icon: 'hiw-card__icon--find-bf',
        text: `${path}.card1`,
        isActive: false,
        id: 1,
      },
      {
        icon: 'hiw-card__icon--payout-bf',
        text: `${path}.card2`,
        isActive: false,
        id: 2,
      },
      {
        icon: 'hiw-card__icon--face-bf',
        text: `${path}.card3`,
        isActive: false,
        id: 3,
      },
      {
        icon: 'hiw-card__icon--deliver-bf',
        text: `${path}.card4`,
        isActive: true,
        id: 4,
      },
    ]
  }
}
